import script from "./PageTask.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTask.vue?vue&type=script&setup=true&lang=js"

import "./PageTask.vue?vue&type=style&index=0&id=c9c1d3f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9c1d3f8"]])

export default __exports__